import React, { Component, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updatePassword } from '../../Actions/Clients'
import swal from 'sweetalert2';
import Input from '../Controls/Input';
import './Styles/settings.css';


export default function Settings() {

    const user = useSelector((state) => state.getIn(['users','single']));

    console.log("user", user);

    if(!user) {
        return null;
    }

    return <div className="card settings">
        <div className="card-header">
            <h1>Instellingen</h1>
        </div>
        <div className="card-body">
             <PasswordChange user={user} />
        </div>
       
    </div>

}



export function PasswordChange({ user }) {

    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const dispatch = useDispatch();

    const savePassword = () => {
        
        let correctLength = password.length > 7;
        let usedCapitals = password.match(/[A-Z]+/);
        let usedDigits = password.match(/[0-9]+/);
        let passwordsAreEqual = password == passwordRepeat;

        if(correctLength && usedCapitals && usedDigits && passwordsAreEqual) {
            
            dispatch(updatePassword(user.delete('setpassword').set('setPassword', password))).then(() => {
                swal.fire({
                    title: 'Uw wachtwoord is gewijzigd',
                    html: `Uw wachtwoord is successvol gewijziged`,
                    type: 'success'
                });
                setPassword('');
                setPasswordRepeat('');
            }).catch(() => {
                swal.fire({
                    title: 'Er heeft zich een fout voorgedaan',
                    html: `Er heeft zich een fout voorgedaan bij het wijzigen van uw wachtwoord, gebeurd dit vaker neem dan contact op met u staat centraal`,
                    type: 'error'
                })
            })

        } else {
             swal.fire({
                title: 'Uw wachtwoord is niet correct',
                html: `<ul style='text-align:left'>
                    ${!passwordsAreEqual && "<li>De door u twee ingevulde wachtwoorden komen niet overeen</li>" || ""}
                    ${!correctLength && "<li>Het wachtwoord moet minimaal 8 tekens bevatten</li>" || ""}
                    ${!usedDigits && "<li>Het wachtwoord moet minimaal 1 cijfer bevatten</li>" || ""}
                    ${!usedCapitals && "<li>Het wachtwoord moet minimaal 1 hoofdletter bevatten</li>" || ""}
                    </ul>
                `,
                type: 'error'
            })
        }
    }

    return <div className="settings-block">
        <h2>Wachtwoord wijzigen</h2>
        <div className="form">
            <div className="form-row">
                <label className="form-label" for="password">Nieuw wachtwoord:</label>
                <Input 
                    onChange={(value) => setPassword(value)} value={password}
                    name="password" id="password" type="password" className="form-control" />
            </div>
            <div className="form-row">
                <label className="form-label" for="password-repeat">Nieuw wachtwoord nogmaals:</label>
                <Input 
                    onChange={(value) => setPasswordRepeat(value)} value={passwordRepeat}
                    name="password-repeat" id="password-repeat" type="password" className="form-control" />
            </div>
            <div className="form-row">
                <label className="form-label">&nbsp;</label>
                <button className="btn btn-success" onClick={() => savePassword()}>Wachtwoord wijzigen</button>
            </div>
        </div>
    </div>

}